import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch as useDispatchOrg, useSelector as useSelectorOrg, useStore as useStoreOrg } from "react-redux";

import type { AppDispatch, RootStoreState } from "./types";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
type DispatchFunc = () => AppDispatch;
export const useDispatch: DispatchFunc = useDispatchOrg;
export const useSelector: TypedUseSelectorHook<RootStoreState> = useSelectorOrg;
export const useStore = useStoreOrg;
